// F-U: marks the first case-insensitive occurrence of the search text, so it
// is clear why a row matched (Exhibit Code or title).

import type { FC } from "react";

const Highlight: FC<{ text: string | null | undefined; query: string }> = ({
  text: raw,
  query,
}) => {
  const text = raw ?? "";
  const needle = query.trim().toLowerCase();
  const at = needle ? text.toLowerCase().indexOf(needle) : -1;
  if (at < 0) return <>{text}</>;
  return (
    <>
      {text.slice(0, at)}
      <mark className="bg-yellow-200 text-inherit rounded-sm px-0.5">
        {text.slice(at, at + needle.length)}
      </mark>
      {text.slice(at + needle.length)}
    </>
  );
};

export default Highlight;
